import { LayerSpecification } from 'maplibre-gl';
import { MapSourceId } from '@daisi/models/map';

export const MSI_SOURCE_ID: MapSourceId = 'realtime-msi';

export const MSI_LAYERS: LayerSpecification[] = [
  {
    id: MSI_SOURCE_ID + '_vms-msi-sign-pictogram',
    type: 'symbol',
    source: MSI_SOURCE_ID,
    maxzoom: 15,
    layout: {
      'icon-image': [
        'concat',
        'ndw-msi-',
        ['get', 'pictogram', ['at', ['get', 'mainSignIndex'], ['get', 'signs']]],
        [
          'case',
          ['==', ['get', 'flashing', ['at', ['get', 'mainSignIndex'], ['get', 'signs']]], true],
          '-flashing',
          '',
        ],
        [
          'case',
          ['==', ['get', 'redRing', ['at', ['get', 'mainSignIndex'], ['get', 'signs']]], true],
          '-red-ring',
          '',
        ],
        '-80',
      ],
      'icon-allow-overlap': false,
      'icon-ignore-placement': false,
      'symbol-sort-key': ['get', 'priorityOfMainIndex'],
      'icon-offset': [50, 0],
      'icon-size': ['interpolate', ['linear'], ['zoom'], 5, 0.2, 10, 0.5, 15, 0.4],
      'icon-rotate': ['get', 'bearing'],
      'icon-rotation-alignment': 'map',
    },
    filter: ['all', ['==', ['get', 'hasActiveSign'], true]],
  },
  {
    id: MSI_SOURCE_ID + '_vms-msi-sign-0-pictogram',
    type: 'symbol',
    source: MSI_SOURCE_ID,
    minzoom: 15,
    layout: {
      'icon-image': [
        'concat',
        'ndw-msi-',
        ['get', 'pictogram', ['at', 0, ['get', 'signs']]],
        ['case', ['==', ['get', 'flashing', ['at', 0, ['get', 'signs']]], true], '-flashing', ''],
        ['case', ['==', ['get', 'redRing', ['at', 0, ['get', 'signs']]], true], '-red-ring', ''],
        '-80',
      ],
      'icon-allow-overlap': true,
      'symbol-sort-key': ['get', 'averagePriority'],
      'icon-ignore-placement': true,
      'icon-offset': [50, 0],
      'icon-size': ['interpolate', ['linear'], ['zoom'], 5, 0.2, 10, 0.5, 15, 0.4],
      'icon-rotate': ['get', 'bearing'],
      'icon-rotation-alignment': 'map',
    },
    filter: ['all', ['>=', ['length', ['get', 'signs']], 1]],
  },
  {
    id: MSI_SOURCE_ID + '_vms-msi-sign-1-pictogram',
    type: 'symbol',
    source: MSI_SOURCE_ID,
    minzoom: 15,
    layout: {
      'icon-image': [
        'concat',
        'ndw-msi-',
        ['get', 'pictogram', ['at', 1, ['get', 'signs']]],
        ['case', ['==', ['get', 'flashing', ['at', 1, ['get', 'signs']]], true], '-flashing', ''],
        ['case', ['==', ['get', 'redRing', ['at', 1, ['get', 'signs']]], true], '-red-ring', ''],
        '-80',
      ],
      'icon-allow-overlap': true,
      'symbol-sort-key': ['get', 'averagePriority'],
      'icon-ignore-placement': true,
      'icon-offset': [131, 0],
      'icon-size': ['interpolate', ['linear'], ['zoom'], 5, 0.2, 10, 0.5, 15, 0.4],
      'icon-rotate': ['get', 'bearing'],
      'icon-rotation-alignment': 'map',
    },
    filter: ['all', ['>=', ['length', ['get', 'signs']], 2]],
  },
  {
    id: MSI_SOURCE_ID + '_vms-msi-sign-2-pictogram',
    type: 'symbol',
    source: MSI_SOURCE_ID,
    minzoom: 15,
    layout: {
      'icon-image': [
        'concat',
        'ndw-msi-',
        ['get', 'pictogram', ['at', 2, ['get', 'signs']]],
        ['case', ['==', ['get', 'flashing', ['at', 2, ['get', 'signs']]], true], '-flashing', ''],
        ['case', ['==', ['get', 'redRing', ['at', 2, ['get', 'signs']]], true], '-red-ring', ''],
        '-80',
      ],
      'icon-allow-overlap': true,
      'symbol-sort-key': ['get', 'averagePriority'],
      'icon-ignore-placement': true,
      'icon-offset': [212, 0],
      'icon-size': ['interpolate', ['linear'], ['zoom'], 5, 0.2, 10, 0.5, 15, 0.4],
      'icon-rotate': ['get', 'bearing'],
      'icon-rotation-alignment': 'map',
    },
    filter: ['all', ['>=', ['length', ['get', 'signs']], 3]],
  },
  {
    id: MSI_SOURCE_ID + '_vms-msi-sign-3-pictogram',
    type: 'symbol',
    source: MSI_SOURCE_ID,
    minzoom: 15,
    layout: {
      'icon-image': [
        'concat',
        'ndw-msi-',
        ['get', 'pictogram', ['at', 3, ['get', 'signs']]],
        ['case', ['==', ['get', 'flashing', ['at', 3, ['get', 'signs']]], true], '-flashing', ''],
        ['case', ['==', ['get', 'redRing', ['at', 3, ['get', 'signs']]], true], '-red-ring', ''],
        '-80',
      ],
      'icon-allow-overlap': true,
      'symbol-sort-key': ['get', 'averagePriority'],
      'icon-ignore-placement': true,
      'icon-offset': [293, 0],
      'icon-size': ['interpolate', ['linear'], ['zoom'], 5, 0.2, 10, 0.5, 15, 0.4],
      'icon-rotate': ['get', 'bearing'],
      'icon-rotation-alignment': 'map',
    },
    filter: ['all', ['>=', ['length', ['get', 'signs']], 4]],
  },
  {
    id: MSI_SOURCE_ID + '_vms-msi-sign-4-pictogram',
    type: 'symbol',
    source: MSI_SOURCE_ID,
    minzoom: 15,
    layout: {
      'icon-image': [
        'concat',
        'ndw-msi-',
        ['get', 'pictogram', ['at', 4, ['get', 'signs']]],
        ['case', ['==', ['get', 'flashing', ['at', 4, ['get', 'signs']]], true], '-flashing', ''],
        ['case', ['==', ['get', 'redRing', ['at', 4, ['get', 'signs']]], true], '-red-ring', ''],
        '-80',
      ],
      'icon-allow-overlap': true,
      'symbol-sort-key': ['get', 'averagePriority'],
      'icon-ignore-placement': true,
      'icon-offset': [374, 0],
      'icon-size': ['interpolate', ['linear'], ['zoom'], 5, 0.2, 10, 0.5, 15, 0.4],
      'icon-rotate': ['get', 'bearing'],
      'icon-rotation-alignment': 'map',
    },
    filter: ['all', ['>=', ['length', ['get', 'signs']], 5]],
  },
  {
    id: MSI_SOURCE_ID + '_vms-msi-sign-5-pictogram',
    type: 'symbol',
    source: MSI_SOURCE_ID,
    minzoom: 15,
    layout: {
      'icon-image': [
        'concat',
        'ndw-msi-',
        ['get', 'pictogram', ['at', 5, ['get', 'signs']]],
        ['case', ['==', ['get', 'flashing', ['at', 5, ['get', 'signs']]], true], '-flashing', ''],
        ['case', ['==', ['get', 'redRing', ['at', 5, ['get', 'signs']]], true], '-red-ring', ''],
        '-80',
      ],
      'icon-allow-overlap': true,
      'symbol-sort-key': ['get', 'averagePriority'],
      'icon-ignore-placement': true,
      'icon-offset': [455, 0],
      'icon-size': ['interpolate', ['linear'], ['zoom'], 5, 0.2, 10, 0.5, 15, 0.4],
      'icon-rotate': ['get', 'bearing'],
      'icon-rotation-alignment': 'map',
    },
    filter: ['all', ['>=', ['length', ['get', 'signs']], 6]],
  },
  {
    id: MSI_SOURCE_ID + '_vms-msi-sign-6-pictogram',
    type: 'symbol',
    source: MSI_SOURCE_ID,
    minzoom: 15,
    layout: {
      'icon-image': [
        'concat',
        'ndw-msi-',
        ['get', 'pictogram', ['at', 6, ['get', 'signs']]],
        ['case', ['==', ['get', 'flashing', ['at', 6, ['get', 'signs']]], true], '-flashing', ''],
        ['case', ['==', ['get', 'redRing', ['at', 6, ['get', 'signs']]], true], '-red-ring', ''],
        '-80',
      ],
      'icon-allow-overlap': true,
      'symbol-sort-key': ['get', 'averagePriority'],
      'icon-ignore-placement': true,
      'icon-offset': [536, 0],
      'icon-size': ['interpolate', ['linear'], ['zoom'], 5, 0.2, 10, 0.5, 15, 0.4],
      'icon-rotate': ['get', 'bearing'],
      'icon-rotation-alignment': 'map',
    },
    filter: ['all', ['>=', ['length', ['get', 'signs']], 7]],
  },
  {
    id: MSI_SOURCE_ID + '_vms-msi-sign-7-pictogram',
    type: 'symbol',
    source: MSI_SOURCE_ID,
    minzoom: 15,
    layout: {
      'icon-image': [
        'concat',
        'ndw-msi-',
        ['get', 'pictogram', ['at', 7, ['get', 'signs']]],
        ['case', ['==', ['get', 'flashing', ['at', 7, ['get', 'signs']]], true], '-flashing', ''],
        ['case', ['==', ['get', 'redRing', ['at', 7, ['get', 'signs']]], true], '-red-ring', ''],
        '-80',
      ],
      'icon-allow-overlap': true,
      'symbol-sort-key': ['get', 'averagePriority'],
      'icon-ignore-placement': true,
      'icon-offset': [617, 0],
      'icon-size': ['interpolate', ['linear'], ['zoom'], 5, 0.2, 10, 0.5, 15, 0.4],
      'icon-rotate': ['get', 'bearing'],
      'icon-rotation-alignment': 'map',
    },
    filter: ['all', ['>=', ['length', ['get', 'signs']], 8]],
  },
];
